import { MobileNotSupportedComponent } from "../mobile-not-supported/mobile-not-supported.component";
import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Renderer2,
  NgZone,
  Output,
  Input,
  HostListener,
} from "@angular/core";

import { ChangeDetectorRef } from "@angular/core";
import { Router, ActivatedRoute, RouterLinkActive } from "@angular/router";
import { MediaService } from "src/app/service/media.service";
import { SearchHistoryService } from "../../service/search-history.service";
import moment from "moment";
import {
  DaterangepickerDirective,
  NgxDaterangepickerMd,
} from "ngx-daterangepicker-material";
import { saveAs } from "file-saver";
import { UserService } from "../../service/user.service";
import { DataFilterService } from "../../data-filter.service";
import { debounceTime } from "rxjs/operators";
import {
  alertModalWithoutConfirm,
  alertModal,
  alertModalDelete,
} from "../helpers/alert";
import { fromEvent, interval, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { PaginationService } from "src/app/service/pagination.service";
import { FormControl, ReactiveFormsModule, FormsModule } from "@angular/forms";
import EventEmitter from "events";
import { BidiModule } from "@angular/cdk/bidi";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgStyle, NgClass, DatePipe } from "@angular/common";
import { HeaderComponent } from "../header/header.component";
import { ChatService } from "src/app/service/chat.service";

declare var $: any;

@Component({
    selector: "app-collection",
    templateUrl: "./collection.component.html",
    styleUrls: ["./collection.component.css"],
    imports: [
        HeaderComponent,
        MobileNotSupportedComponent,
        NgStyle,
        ReactiveFormsModule,
        FormsModule,
        NgClass,
        RouterLinkActive,
        NgxDaterangepickerMd,
        InfiniteScrollModule,
        BidiModule,
        DatePipe,
    ]
})
export class CollectionComponent implements AfterViewInit {
  private destroy$: Subject<void> = new Subject<void>();
  @ViewChild(DaterangepickerDirective, { static: true })
  picker!: DaterangepickerDirective;
  @ViewChild("matSortBy") private matSortBy: ElementRef;
  @ViewChild("mediaElement") mediaElement: ElementRef;
  @ViewChild("infiniteScroller") infiniteScroller: ElementRef;
  @ViewChild("multiSearchTerm") multiSearchTerm: ElementRef;
isFilterDropdownOpen = false;
@ViewChild('filterDropdownContainer', { static: false }) filterDropdownContainer!: ElementRef;
@ViewChild('filterDropdownMenu', { static: false }) filterDropdownMenu!: ElementRef<HTMLUListElement>; 
// @Input() totalUnreadCount: number = 0;
  selected: { startDate: moment.Moment; endDate: moment.Moment };
  name = "Angular";
open(event?: Event): void {
 event?.stopPropagation();
  event?.preventDefault(); 
  this.closeFilterDropdown();

  setTimeout(() => {
    if (this.picker) {
      this.picker.open();
      this.isDatepickerOpen = true;
    }
  }, 0);
}

isDatepickerOpen = false;
onDatepickerHide() {
  this.isDatepickerOpen = false;
}

openDatepicker(event?: Event): void {
  event?.stopPropagation();
  event?.preventDefault();

  if (this.filterDropdownMenu) {
    this.filterDropdownMenu.nativeElement.style.display = 'none';
    this.filterDropdownMenu.nativeElement.classList.remove('show');
  }

  this.isFilterDropdownOpen = false;

  if (this.picker) {
    this.picker.open();
    this.isDatepickerOpen = true;
  }
}

toggleFilterDropdown(event?: Event): void {
  event?.stopPropagation();
  event?.preventDefault();

  if (this.picker && this.isDatepickerOpen) {
    this.picker.hide();
    this.isDatepickerOpen = false;
  }

  if (this.filterDropdownMenu) {
    this.filterDropdownMenu.nativeElement.style.display = 'block';
    this.filterDropdownMenu.nativeElement.classList.add('show');
  }

  this.isFilterDropdownOpen = true;
}

closeFilterDropdown() {
  this.isFilterDropdownOpen = false;
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: Event) {
  const target = event.target as HTMLElement;

  if (
    this.filterDropdownMenu &&
    !this.filterDropdownMenu.nativeElement.contains(target) &&
    !target.closest('.btn.dropdown-toggle') 
  ) {
    this.filterDropdownMenu.nativeElement.style.display = 'none';
    this.filterDropdownMenu.nativeElement.classList.remove('show');
    this.isFilterDropdownOpen = false;
  }
}

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  pdfDisplay: string = "none";
  pdfUrl: string = "";
  excelUrl: string = "";
  pptxUrl: string = "";
  docsUrl: string = "";
  jsUrl: string = "";
  PdfDetails = [];
  isHovered = false;
  searchTerm: string;
  tagsSearch: any;
  filteredName: string;
  searchHistory: string[];
  mostRecentSearch: string | null;
  recentFiveTags: string[];
  client_names: any[];
  uploader_names = [];
  completePath: any;
  currentPath: any = "normal-view";
  mediaId: string;
  selectedDateRange: { startDate: moment.Moment; endDate: moment.Moment };
  newCollection = true;
  allDataForFilter = [];
  constructor(
    private mediaService: MediaService,
    private router: Router,
    private searchHistoryService: SearchHistoryService,
    private renderer: Renderer2,
    private UserService: UserService,
    private dataFilterService: DataFilterService,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private paginationService: PaginationService,
    private cdRef: ChangeDetectorRef,
    private chatService: ChatService
  ) {
    this.searchHistory = this.searchHistoryService.getSearchHistory();
    this.mostRecentSearch = this.searchHistoryService.getMostRecentSearch();
    this.recentFiveTags = this.searchHistoryService.getRecentFiveTags();
    this.selectedDateRange1 = { startDate: null, endDate: null };
    window.addEventListener("click", this.closeDropdown.bind(this));
    window.addEventListener("click", this.closeDropdown1.bind(this));

    this.route.url.subscribe((segments) => {
      this.completePath =
        "/" + segments.map((segment) => segment.path).join("/");
    });
  }

  selectedCount = 0;
  selectedDateRange1: any;
  @Output() renameRequest = new EventEmitter();
  searchControl = new FormControl();
  ngAfterViewInit() {
    this.detectPortrait();

    const hash = window.location.hash;
    const segments = hash.substring(1).split("/");

    let path = segments[2];

    if (path == "private") {
      this.activeTab = "playlistUser";
    }

    if (path == "public") {
      this.activeTab = "playlistDiv";
    }

    // Added a sick debounceTime for checking the email validation yay
    fromEvent(this.multiSearchTerm.nativeElement, "input")
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.mediaService
          .getTags(this.searchTerm)
          .subscribe((tags: { data: any }) => {
            this.tagsSearch = tags.data;
            setTimeout(() => {}, 40000);
          });
      });
  }

  multiTagSearch(tagsFilter: string) {
    if (this.tags.includes(tagsFilter)) return;
    this.tags.push(tagsFilter);
    this.searchHistoryService.addToHistory(this.searchTerm);
    this.mediaService.getUserCollection(this.tags).subscribe((resp) => {
      if (resp["operation"] == false) {
        document.getElementById("notFound").innerHTML = "";
        this.notFoundResult = true;
      } else {
        document.getElementById("notFound").innerHTML = "";
        this.notFoundResult = false;
      }
      if (resp["operation"] == true) {
        document.getElementById("notFound").innerHTML = "";
        this.notFoundResult = false;
      }
      if (resp["data"].medias == undefined || resp["data"].medias.length == 0) {
        this.mediaService.mediaData = resp["data"].medias;
        this.cardData = [];
        this.notFoundResult = true;
      }
      if (resp["data"].medias.length > 0) {
        this.cardData = resp["data"].medias;
        this.totalMedia = this.cardData.length;
        // let videoLength = document.getElementById("videoLength");
        // videoLength.textContent = `${this.cardData.length} Files`;
      }
    });
  }
  detectPortrait() {
    return;
    const media = this.mediaElement.nativeElement;

    if (media instanceof HTMLVideoElement) {
      if (media.videoWidth > media.videoHeight) {
        this.renderer.addClass(media, "landscape-video");
      } else {
        this.renderer.addClass(media, "portrait-video");
      }
    }
  }

  isPortrait(mediaElement: HTMLElement): boolean {
    return mediaElement.classList.contains("portrait-video");
  }

  cardData;
  cardDataPermanent;
  tags = [];
  searchTags = [];
  searchTagsDisplay = [];
  imageDis: boolean = false;
  videoDis: boolean = false;
  orginalFileName: string = "";
  orginal: boolean = false;
  searchValidation: string = "";
  collectionTypeToggle: boolean = false;
  typeToggle: boolean = false;
  currentPathPlay: any;
  playAccess: boolean = false;
  membername: string;
  memberId: string;
  hasRouteChanged: boolean = true;
  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  ngOnInit(): void {

     this.allUsersOriginal = JSON.parse(JSON.stringify(this.allUsers));
     this.filteredUsers = [...this.allUsers];
    // refetching the previous routed data
    this.route.queryParams.subscribe((params: any) => {
      if (params?.type == "public") {
        this.playListOpen(false);
      } else if (params?.type == "private") {
        this.playUsers(false);
      } else {
        this.dataFilterService.disableUser.subscribe((res) => {
          if (res.data == "playlist-user-login") {
            this.playAccess = true;
            let side = document.getElementById("navSideDis");
            side.style.setProperty("display", "none", "important");
            let sideRight = document.getElementById("navSideDisRight");
            sideRight.style.setProperty("display", "none", "important");
            let element = document.querySelector(".col-lg-10") as HTMLElement;
            element.style.transform = "translate(10%, 8%)";
          }
        });
        this.tabViewHandler("normal");
      }
    });

    this.ngZone.run(() => {
      this.dataFilterService.searchData.pipe(take(5)).subscribe((res) => {
        if (res.event.key == "Enter") {
          this.onSearchKeyPress(res.event);
        }
      });
    });

    this.mediaService.tempUploads$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.processAndDisplayData(this.currentTabView, [], false);
        this.cdRef.detectChanges();
      });

    this.mediaService.mediaUploaded$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data) {
          if (this.allPagesData) {
            const index = this.allPagesData.findIndex((item) => item._id === data._id);
            if (index > -1) {
              this.allPagesData[index] = { ...this.allPagesData[index], ...data };
            } else {
              this.allPagesData = [data, ...this.allPagesData];
            }
          }
          this.processAndDisplayData(this.currentTabView, [], false);
          this.cdRef.detectChanges();
        }
      });

    this.chatService.listen("ARCHIVE")
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res?.operation && res?.data) {
          const data = res.data;
          this.mediaService.removeTempUpload(data._id);
          if (this.allPagesData) {
            const index = this.allPagesData.findIndex((item) => item._id === data._id);
            if (index > -1) {
              this.allPagesData[index] = { ...this.allPagesData[index], ...data };
            } else {
              this.allPagesData = [data, ...this.allPagesData];
            }
          }
          this.processAndDisplayData(this.currentTabView, [], false);
          this.cdRef.detectChanges();
        }
      });

    this.getInvitation();
    this.getOneUserDetails();
   this.loadData(this.currentView, false);
  }

  getCurrentEndPath(path) {
    const segments = path.split("/");

    return segments[2];
  }

  sortByDate() {
    this.open();
  }
  working(id, event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName.toLowerCase() === "input") {
      return;
    }
    const card = (this.cardData || []).find((c: any) => c && (c._id === id || c.mediaId === id));
    if (card && card.isUploading) {
      alertModalWithoutConfirm("info", "Upload in progress. Please wait until all files finish uploading.");
      return;
    }
    this.mediaService.selectedMedia = card || (typeof id === 'number' ? this.cardData[id] : null);
    this.router.navigate(["single", id]);
  }

  handleDropdownItemClick(event: Event) {
    event.stopPropagation();
  }

  workingfocus() {
    if ((<HTMLInputElement>document.getElementById("search")).value != "") {
    } else {
    }
  }
  guestId = localStorage.getItem("guestID");
  loggedInUsername: string = localStorage.getItem("username") || "";
  userId: string;
  dynamicStyle: any = {};
  selectedOptions: any;
  selectedOption: string;
  notFoundResult1: boolean = false;
selectOption(option: string) {
  this.nameDisplay = "";
  this.selectedOption = option;
  this.dataFilterService.selectAndOption(option);
  
  if (option === "public") {
    this.collectionTypeToggle = !this.collectionTypeToggle;
    this.selectedOptions = option;
    if (this.tags.includes("private")) {
      this.tags = this.tags.filter((tag) => tag !== "private");
    }
    if (!this.tags.includes("public")) {
      this.tags.push(option);
    }
    this.dynamicStyle = { "background-color": "#FECC28" };
  } else if (option === "private") {
    this.collectionTypeToggle = !this.collectionTypeToggle;
    this.selectedOptions = option;
    this.notFoundResult = false;
    if (this.tags.includes("public")) {
      this.tags = this.tags.filter((tag) => tag !== "public");
    }
    if (!this.tags.includes("private")) {
      this.tags.push(option);
    }
    this.dynamicStyle = { "background-color": "#FECC28" };
  } else if (option === "company") {
    this.typeToggle = !this.typeToggle;
    if (this.tags.includes("reference")) {
      this.tags = this.tags.filter((tag) => tag !== "reference");
    }
    if (!this.tags.includes("company")) {
      this.tags.push(option);
    }
    this.dynamicStyle = { "background-color": "#FECC28" };
  } else if (option === "reference") {
    this.typeToggle = !this.typeToggle;
    if (this.tags.includes("company")) {
      this.tags = this.tags.filter((tag) => tag !== "company");
    }
    if (!this.tags.includes("reference")) {
      this.tags.push(option);
    }
    this.dynamicStyle = { "background-color": "#FECC28" };
  }

  this.tags = Array.from(new Set(this.tags));
  this.searchTagsDisplay = [];

  // Reset pagination data when filtering
  this.allPagesData = [];
  this.allDataForFilter = [];
  this.isShimmerLoading = true;

  // Make API call based on user role
  if (localStorage.getItem("department") == "admin") {
    this.mediaService.getAdminCollection(this.tags).subscribe(
      (resp: any) => {
        this.handleApiResponse(resp, false);
      },
      (error) => {
        console.error("Error fetching admin collection:", error);
        this.handleApiError();
      }
    );
  } else {
    this.mediaService.getUserCollection(this.tags).subscribe(
      (resp: any) => {
        this.handleApiResponse(resp, true);
      },
      (error) => {
        console.error("Error fetching user collection:", error);
        this.handleApiError();
      }
    );
  }
}

private handleApiResponse(resp: any, isUser: boolean) {
  if (resp?.operation === false) {
    this.notFoundResult = true;
    this.cardData = [];
    this.allDataForFilter = [];
    this.isShimmerLoading = false;
    return;
  }

  let mediaData: any[] = [];
  if (isUser) {
    this.totalMedia = resp?.data?.totalMedias || 0;
    mediaData = resp?.data?.medias || [];
  } else {
    mediaData = resp?.data || [];
  }

  this.mediaService.mediaData = mediaData;
  this.cardData = [...mediaData];
  this.allDataForFilter = [...mediaData];
  this.allPagesData = [...mediaData];

  this.notFoundResult = mediaData.length === 0;
  this.isShimmerLoading = false;

  const searchInput = document.getElementById("search") as HTMLInputElement;
  if (searchInput) {
    searchInput.value = "";
  }

  console.log(`Filtered by ${this.tags.join(', ')}: ${mediaData.length} items found`);
}

private handleApiError() {
  this.notFoundResult = true;
  this.cardData = [];
  this.allDataForFilter = [];
  this.isShimmerLoading = false;
  document.getElementById("notFound")!.innerHTML = "Error loading data";
}

  filterSearch(elementEvent) {
    const searchTerm: string = elementEvent.target.value.trim();
    this.dataFilterService.searchFilterPass(searchTerm, elementEvent);
  }

onSearchKeyPress(elementEvent) {
  const searchTerm: string = elementEvent.target.value.trim();
  if (searchTerm === "" || this.tags.includes(searchTerm)) {
    return;
  }
  if (
    (searchTerm == "public" && this.tags.includes("private")) ||
    (searchTerm == "private" && this.tags.includes("public"))
  ) {
    this.searchValidation = "Invalid Search";
    return;
  }
  
  if (elementEvent.key == "Enter" || elementEvent.key == "click") {
    const searchInput = document.getElementById("search") as HTMLInputElement;
    const val = searchInput?.value || "";
    
    if (searchInput) {
      searchInput.value = "";
    }
    
    this.searchTagsDisplay = [];

    if (val != "") {
      this.tags.push(val);
      this.dataFilterService.searchFilterPass(searchTerm, elementEvent);
      this.searchHistoryService.addToHistory(searchTerm);

      // Reset pagination data
      this.allPagesData = [];
      this.allDataForFilter = [];
      this.isShimmerLoading = true;

      if (localStorage.getItem("department") == "admin") {
        this.mediaService.getAdminCollection(this.tags).subscribe(
          (resp: any) => {
            this.handleSearchResponse(resp, false);
          },
          (error) => {
            console.error("Error in admin search:", error);
            this.handleSearchError();
          }
        );
      } else {
        this.mediaService.getUserCollection(this.tags).subscribe(
          (resp: any) => {
            this.handleSearchResponse(resp, true);
          },
          (error) => {
            console.error("Error in user search:", error);
            this.handleSearchError();
          }
        );
      }
    }
  } else {
    const searchInput = document.getElementById("search") as HTMLInputElement;
    if (searchInput?.value != "") {
      this.searchTagsDisplay = this.searchTags.filter((word) => {
        return word.includes(searchInput.value);
      });

      let unique = [];
      for (const tag of this.searchTagsDisplay) {
        if (!unique.includes(tag)) {
          unique.push(tag);
        }
      }

      const uniqueArray = Array.from(
        new Set(this.searchTagsDisplay.map((str) => str.toLowerCase()))
      );
      this.searchTagsDisplay = Array.from(new Set(this.searchTagsDisplay));

      this.dataFilterService.searchFilterPass(searchTerm, elementEvent);
    } else {
      this.searchTagsDisplay = [];
      this.dataFilterService.searchFilterPass(searchTerm, elementEvent);
    }
  }
  
  this.searchHistory = this.searchHistoryService.getSearchHistory();
  this.searchHistory = Array.from(new Set(this.searchHistory));
  this.mostRecentSearch = this.searchHistoryService.getMostRecentSearch();
  this.recentFiveTags = this.searchHistoryService.getRecentFiveTags();
  this.recentFiveTags = Array.from(new Set(this.recentFiveTags));
}

// Helper method for search response
private handleSearchResponse(resp: any, isUser: boolean) {
  if (resp?.operation === false) {
    this.notFoundResult = true;
    this.cardData = [];
    this.allDataForFilter = [];
    this.isShimmerLoading = false;
    return;
  }

  // Extract data based on user/admin
  let mediaData: any[] = [];
  if (isUser) {
    this.totalMedia = resp?.data?.totalMedias || 0;
    mediaData = resp?.data?.medias || [];
  } else {
    mediaData = resp?.data || [];
  }

 
  this.mediaService.mediaData = mediaData;
  this.cardData = [...mediaData];
  this.allDataForFilter = [...mediaData];
  this.allPagesData = [...mediaData];

  this.notFoundResult = mediaData.length === 0;
  this.isShimmerLoading = false;

  console.log(`Search results: ${mediaData.length} items found`);
}

// Helper method for search error
private handleSearchError() {
  this.notFoundResult = true;
  this.cardData = [];
  this.allDataForFilter = [];
  this.isShimmerLoading = false;
}

// Safe autocomplete method
private safeAutocomplete() {
  const searchInput = document.getElementById("search") as HTMLInputElement;
  if (searchInput) {
    this.autocomplete(searchInput, []);
  }
}

  removeTag(idx) {
    this.tags.splice(idx, 1);
    this.dataFilterService.removeTagFunction(idx);
    // this.searchTerm = "";
    if (this.tags.length === 0) {
      this.selectedOption = "";
      this.dynamicStyle = {};
    }

    if (this.currentTabView === "public") {
      this.mediaService
        .getPublicCollection(
          [],
          this.currentPublicPage,
          this.selectedPublicLimit
        )
        .subscribe((resp) => {
          this.mediaService.mediaData = resp["data"].collections;
          this.cardData = this.mediaService.mediaData.filter((card: any) => {
            return card.creatorId != localStorage.getItem("guestID");
          });
          this.totalMedia = resp["data"].totalCollections;
          this.cardData.map((card) => {
            this.uploader_names.push(card);
            try {
              this.handlePuplicFileView(card);
            } catch (error) {}
          });
          this.isShimmerLoading = false;
          this.route.queryParams.subscribe((params: any) => {
            if (params?.id) {
              this.cardData.map((card) => {
                if (card._id == params.id) {
                  this.displayPlayList(
                    card._id,
                    0,
                    card.isPublic,
                    card.creatorId,
                    false
                  );
                }
              });
            }
          });

          this.PdfDetails = this.PdfDetails.filter(
            (detail, index, self) =>
              index === self.findIndex((d) => d.filename === detail.filename)
          );
        });
    } else if (this.currentTabView === "private") {
      this.mediaService
        .getPrivateCollection(
          [],
          this.currentPublicPage,
          this.selectedPublicLimit
        )
        .subscribe((resp) => {
          this.mediaService.mediaData = resp["data"].collections;
          this.cardData = this.mediaService.mediaData;
          this.totalMedia = resp["data"].totalCollections;
          this.cardDataPermanent = this.mediaService.mediaData;
          this.cardData.map((card) => {
            this.uploader_names.push(card);
            this.handlePuplicFileView(card);
          });
          this.route.queryParams.subscribe((params: any) => {
            if (params?.id) {
              this.cardData.map((card) => {
                if (card._id == params.id) {
                  this.displayPlayList(
                    card._id,
                    0,
                    card.isPublic,
                    card.creatorId,
                    false
                  );
                }
              });
            }
          });

          this.isShimmerLoading = false;

          this.PdfDetails = this.PdfDetails.filter(
            (detail, index, self) =>
              index === self.findIndex((d) => d.filename === detail.filename)
          );
        });
    } else {
      if (localStorage.getItem("department") == "admin") {
        this.mediaService.getAdminCollection(this.tags).subscribe((resp) => {
          this.mediaService.mediaData = resp["data"]["medias"];
          this.cardData = this.mediaService.mediaData;

          if (resp["data"].length > 0) {
            this.notFoundResult = false;
            document.getElementById("notFound").innerHTML = "";
            document.getElementById("notFound").style.display = "none";
          }
        });
      } else {
        this.mediaService.getUserCollection(this.tags).subscribe((resp) => {
          this.mediaService.mediaData = resp["data"]["medias"];
          console.log(" yo");
          if (this.mediaService.mediaData) {
            this.cardData = this.mediaService.mediaData;

            if (this.cardData.length) {
              this.notFoundResult = false;
            } else {
              this.notFoundResult = true;
            }
            console.log("sdd");
            this.totalMedia = resp["data"].totalMedias;
          }
          // if (resp["operation"] == false && this.selectedView !== 5) {
          //   // document.getElementById("notFound").innerHTML = "";
          //   this.notFoundResult = true;
          // } else {
          //   // document.getElementById("notFound").innerHTML = "";
          //   this.notFoundResult = false;
          // }
        });
      }
    }
  }

  autocomplete(inp, arr) {
    var currentFocus;
    inp.addEventListener("input", (e) => {
      let el = e.target;
      var a,
        b,
        i,
        val = el.value;

      closeAllLists();
      if (!val) {
        return false;
      }
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = document.createElement("DIV");
      a.setAttribute("id", el.id + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      el.parentNode.appendChild(a);

      let unique = [];
      for (const tag of arr) {
        if (!unique.includes(tag.toLowerCase())) {
          unique.push(tag.trim());
        }
      }
      arr = unique;

      for (i = 0; i < arr.length; i++) {
        if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
          b = document.createElement("DIV");
          b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
          b.innerHTML += arr[i].substr(val.length);
          b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
          b.addEventListener("click", (e) => {
            inp.value = e.target.getElementsByTagName("input")[0].value;

            this.onSearchKeyPress({
              target: { value: inp.value },
              key: "Enter",
            });
            inp.value = "";
            closeAllLists();
          });
          a.appendChild(b);
        }
      }
    });
    inp.addEventListener("keydown", function (e) {
      var x: any = document.getElementById(this.id + "autocomplete-list");
      if (x) x = x.getElementsByTagName("div");
      if (e.keyCode == 40) {
        currentFocus++;
        addActive(x);
      } else if (e.keyCode == 38) {
        currentFocus--;
        addActive(x);
      } else if (e.keyCode == 13) {
        e.preventDefault();
        if (currentFocus > -1) {
          if (x) x[currentFocus].click();
        }
      }
    });
    function addActive(x) {
      if (!x) return false;
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt = null) {
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }
    document.addEventListener("click", function (e) {
      const target = e.target as HTMLInputElement;
      closeAllLists(e.target);
    });
  }

  public showVideo: boolean = false;

  activeVideoIndex: number = -1;
  showControls(i) {
    this.activeVideoIndex = i;
    const videoElement = document.getElementsByTagName("video");
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      const videoElement = videoElements[i];
      videoElement.addEventListener("mouseenter", function () {
        videoElement.play();
        const videoIndex = i;
      });
    }
    if (videoElement && this.activeVideoIndex == i) {
      // videoElement.play();
    }
  }

  hideControls(i) {
    this.activeVideoIndex = -1;
    const videoElement = document.getElementsByTagName("video");
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      const videoElement = videoElements[i];
      videoElement.addEventListener("mouseout", function () {
        videoElement.pause();
        const videoIndex = i;
      });
    }

    if (videoElement && this.activeVideoIndex !== i) {
      // videoElement.pause();
    }
  }

  replayGif(event: MouseEvent): void {
    const imgElement = event.currentTarget as HTMLImageElement;
    const originalSrc = imgElement.src;

    // Resetting the src attribute by removing and re-adding the element from the DOM
    imgElement.parentNode?.replaceChild(imgElement.cloneNode(true), imgElement);
    setTimeout(() => {
      imgElement.src = originalSrc;
    }, 0);
  }

  playVideo(i: number) {
    this.activeVideoIndex = i;
    const videoElement: HTMLVideoElement = this.getVideoElement(i);
    if (videoElement) {
      videoElement.play();
    }
  }

  pauseVideo(i: number) {
    this.activeVideoIndex = -1;
    const videoElement: HTMLVideoElement = this.getVideoElement(i);
    if (videoElement) {
      videoElement.pause();
    }
  }

  private getVideoElement(i: number): HTMLVideoElement | null {
    const videoElements: NodeListOf<HTMLVideoElement> =
      document.querySelectorAll("video");
    if (videoElements.length > i) {
      return videoElements[i];
    }
    return null;
  }

  toggleVideo(index: number): void {
    setTimeout(() => {
      if (this.activeVideoIndex === index) {
        this.activeVideoIndex = -1;
      } else {
        this.activeVideoIndex = index;
      }
    }, 5000);
  }

  onClearButtonClick(): void {
    this.dataFilterService.sendButton(this.onClearButtonClick);
    this.searchHistoryService.clearHistory();
    this.searchHistory = [];
    this.mostRecentSearch = null;
    this.recentFiveTags = [];
  }

  removeFromHistory(item: string): void {
    this.dataFilterService.removeFromItem(item);
    this.searchHistory = this.searchHistory.filter(
      (historyItem) => historyItem !== item
    );
    this.searchHistoryService.updateHistory(this.searchHistory);
    this.recentFiveTags = this.searchHistoryService.getRecentFiveTags();
  }
  uploadNew() {
    this.router.navigate(["/upload"]);
  }

  filterData(type: string) {
    if (type === "user") {
    }
  }

  gridSelection(num: number) {}

  selectedOption1: string = "public";
  toggleOption() {
    this.selectedOption1 =
      this.selectedOption1 === "public" ? "private" : "public";
  }

  selectedDays: number = 1;
  cardDataFor10Days;

  activeGifIndex: number = -1;
  playVideoOnHover(index: number) {
    if (this.activeGifIndex !== index) {
      this.activeGifIndex = index;
      const video = document.getElementById(
        `video${index}`
      ) as HTMLVideoElement;
      if (video) {
        video.play();
      }
    }
  }

  stopVideoOnHover(index: number) {
    if (this.activeGifIndex === index) {
      const video = document.getElementById(
        `video${index}`
      ) as HTMLVideoElement;
      if (video) {
        video.pause();
      }
      this.activeGifIndex = -1;
    }
  }

  nameList: any[] = [];

filterBaseOnUploader(tab: string) {
  const uniqueNamesSet = new Set<string>();
  
  if (!this.allDataForFilter || this.allDataForFilter.length === 0) {
    console.warn('No data available for uploader filtering');
    this.nameList = ["all"];
    return;
  }

  if (tab === "public") {
    this.allDataForFilter.forEach((item) => {
      if (item?.creatorName?.trim()) {
        uniqueNamesSet.add(item.creatorName.trim());
      }
    });
  } else {
    this.allDataForFilter.forEach((item) => {
      if (item?.uploadedBy?.trim()) {
        uniqueNamesSet.add(item.uploadedBy.trim());
      }
    });
  }
  
  this.nameList = ["all", ...Array.from(uniqueNamesSet)];
  console.log('Available uploaders:', this.nameList);
}

  nameDisplay: string = "Uploaded By";
selectName(selectedName: string, tab: string, event?: Event) {
  event?.stopPropagation();
  event?.preventDefault();
  this.nameDisplay = selectedName;
  let filteredData: any[] = [];
  this.notFoundResult = false;

  if (!this.allDataForFilter || this.allDataForFilter.length === 0) {
    console.warn('No data available for filtering');
    this.notFoundResult = true;
    return;
  }

  if (selectedName === "all") {
    filteredData = this.allDataForFilter; 
  } else {
    filteredData = this.allDataForFilter.filter((data) => {
      if (tab === "public") {
        return data?.creatorName?.trim() === selectedName;
      } else {
        return data?.uploadedBy?.trim() === selectedName;
      }
    });
  }

  this.cardData = [...filteredData];
  this.notFoundResult = this.cardData.length === 0;
  this.totalMedia = this.cardData.length;
  
  console.log(`Filtered by ${selectedName}: ${this.cardData.length} items found`);
}


  selectedView: any = 3;
  gridview: boolean = false;
  GridView(event) {
    this.nameDisplay = "";
    this.selectPlayList = false;
    this.selectPlayListPlay = false;
    this.selectPlayListReq = false;
    this.activeTab = "";
    this.currentPageNume = 1;
    if (event.target.checked) {
      this.selectedView = 4;
      let normal = document.querySelector(".onoffswitch-switch") as HTMLElement;
      normal.style.left = "";
      normal.style.right = "0px";
      var playlistDiv = document.getElementById("playlistDiv");

      if (playlistDiv?.classList?.contains("active")) {
        playlistDiv.classList.remove("active");
      }

      // this.router.navigate(["/collection/grid-view"]);
      this.tabViewHandler("grid");
    } else {
      this.selectedView = 3;
      let normal = document.querySelector(".onoffswitch-switch") as HTMLElement;
      normal.style.left = "0px";
      normal.style.right = "";
      this.tabViewHandler("normal");

      if (playlistDiv?.classList?.contains("active")) {
        playlistDiv.classList.remove("active");
      }
    }
     this.resetDatePlaceholder();
       this.resetDateFilter();
  }

  selectedDate: string;
  dataItems = [];
  notFoundResult: boolean = false;
  selectedStartDate: Date | null = null;
selectedEndDate: Date | null = null;

onDateSelected(event: any) {
  console.log("date selected", event);

  if (!event || !event.startDate || !event.endDate) {
    this.resetDatePlaceholder();
    this.resetDateFilter();
    return;
  }

  const startDate = event.startDate?.toDate ? event.startDate.toDate() : (event.startDate instanceof Date ? event.startDate : new Date(event.startDate));
  const endDate = event.endDate?.toDate ? event.endDate.toDate() : (event.endDate instanceof Date ? event.endDate : new Date(event.endDate));

  if (startDate && endDate && !isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
    this.fromMonthSelected = startDate.toLocaleString("default", { month: "short" });
    this.fromDateSelected = startDate.getDate().toString();
    this.toMonthSelected = endDate.toLocaleString("default", { month: "short" });
    this.toDateSelected = endDate.getDate().toString();
    this.filterDataByDate(startDate, endDate);
    this.dataFilterService.filterSortBy(startDate, endDate);
  } else {
    this.resetDatePlaceholder();
    this.resetDateFilter();
  }
}

resetDatePlaceholder() {
  this.fromMonthSelected = null;
  this.fromDateSelected = null;
  this.toMonthSelected = null;
  this.toDateSelected = null;
}

resetDateFilter() {
  this.selectedStartDate = null;
  this.selectedEndDate = null;

  this.dataFilterService.filterSortBy(null, null);

  if (this.allDataForFilter && this.allDataForFilter.length > 0) {
    this.cardData = [...this.allDataForFilter];
    this.notFoundResult = false;
    this.totalMedia = this.cardData.length;
  }
}


  fromDateSelected: any;
  fromMonthSelected: any;
  toDateSelected: any;
  toMonthSelected: any;

filterDataByDate(startDate: Date, endDate: Date) {
  if (!startDate || !endDate) {
    console.error('Invalid dates provided');
    return;
  }

  if (!this.allDataForFilter || this.allDataForFilter.length === 0) {
    console.warn('No data available for date filtering');
    this.notFoundResult = true;
    return;
  }

  this.cardData = this.allDataForFilter.filter((media) => {
    if (!media.createdAt) return false;
    
    const mediaDate = new Date(media.createdAt);
    const mediaDateOnly = new Date(mediaDate.getFullYear(), mediaDate.getMonth(), mediaDate.getDate());
    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    
    return mediaDateOnly >= startDateOnly && mediaDateOnly <= endDateOnly;
  });

  this.notFoundResult = this.cardData.length === 0;
  this.totalMedia = this.cardData.length;
}

  filterMediaByDays(
    mediaData: any[],
    startDate: moment.Moment,
    endDate: moment.Moment
  ) {
    return mediaData.filter((media) => {
      const createdAtDate = moment(media.createdAt);
      return createdAtDate.isBetween(startDate, endDate, null, "[]");
    });
  }

  clearDateRange() {
    this.selectedDateRange = { startDate: null, endDate: null };
  }


  
filterItemsByExtension(extension: string, event?: Event) {
  event?.stopPropagation();
  event?.preventDefault();
  this.notFoundResult = false;
  this.filteredName = extension;

  if (!this.allDataForFilter || this.allDataForFilter.length === 0) {
    console.warn('No data available for filtering');
    this.notFoundResult = true;
    return;
  }

  if (extension === "all") {
    this.cardData = this.allDataForFilter;
  } else {
    this.cardData = this.allDataForFilter.filter((media) => {
      const fileExt = media.extension?.toLowerCase().replace('.', '') || '';
      
      switch(extension) {
        case "images": return ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(fileExt);
        case "pdf": return fileExt === 'pdf';
        case "excel": return ['xlsx', 'xls', 'csv'].includes(fileExt);
        case "docs": return ['doc', 'docx', 'txt', 'rtf'].includes(fileExt);
        case "videos": return ['mp4', 'webm', 'mov', 'mkv', 'avi', 'wmv', 'flv'].includes(fileExt);
        case "pptx": return ['ppt', 'pptx', 'pptm'].includes(fileExt);
        default: return false;
      }
    });
  }

  this.notFoundResult = this.cardData.length === 0;
  this.totalMedia = this.cardData.length;
}

  ngOnDestroy() {
    this.muteVideoOnScroll();
    this.savePlayList(0, null);
    // this.shareList(null);
    $(".modal-backdrop").remove();
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.style.position = "";
    document.body.style.height = "";
    document.body.style.width = "";
    this.destroy$.next();
    this.destroy$.complete();
  }
  muteVideoOnScroll() {
    const video = document.getElementById("video") as HTMLVideoElement;
    if (video) {
      video.muted = true;
    }
  }

  isDropdownOpen: number | null = null;
  isDropdownOpen1: number | null = null;

  showDropdown(index: number) {
    index = index;
    if (this.isDropdownOpen === index) {
      this.isDropdownOpen = null;
    } else {
      this.isDropdownOpen = index;
    }
  }

  closeDropdown(event: Event) {
    if (
      !(event.target instanceof HTMLElement) ||
      !event.target.matches(".dropbtn")
    ) {
      this.isDropdownOpen = null;
    }
  }

  closeDropdown1(event: Event) {
    if (
      !(event.target instanceof HTMLElement) ||
      !event.target.matches(".dropbtn")
    ) {
      this.isDropdownOpen1 = null;
    }
  }

  getOne(id) {
    this.mediaService.getOneByMediaId(id).subscribe((res: any) => {
      if ([".mp4", ".webm", ".mov", ".mkv"].includes(res["data"].extension)) {
        fetch(res["data"].lg)
          .then((response) => response.blob())
          .then((blob) => {
            saveAs(blob, `${res["data"].title}.mp4`);
          })
          .catch((error) => {
            console.error("Error downloading the file:", error);
          });
      }

      if ([".png", ".jpg", ".jpeg", ".webp"].includes(res["data"].extension)) {
        const imageUrl = res["data"].ogFileUrl;
        const a = document.createElement("a");
        a.href = imageUrl;
        a.download = imageUrl;
        a.click();
      }
    });
  }

  download(id) {
    this.getOne(id);
  }
  modalVisible = false;
  OneCardDetails: any;
  selectedTagId: any;
  selectedCollectionIndex: number;
  savePlayList(index: number, id: any) {
    this.OneCardDetails = this.cardData.filter((item) => item._id == id);
    this.collectionType = "";
    this.collectionTags = "";
    this.modalVisible = true;
    this.mediaId = id;
    if (this.isDropdownOpen1 === index) {
      this.isDropdownOpen1 = null;
    } else {
      this.isDropdownOpen1 = index;
    }

    let saveModalEl = document.querySelector("#saveModal");
    let saveModal = new (window as any).bootstrap.Modal(saveModalEl);
    saveModal.show();
    this.addToExistingCollection();
  }
  playListview: boolean = false;

  closeModal(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.modalVisible = false;

      let saveModalEl = document.querySelector("#saveModal");
      let saveModal = new (window as any).bootstrap.Modal(saveModalEl);

      saveModalEl.addEventListener("hidden.bs.modal", () => {
        this.removeModalElement(saveModalEl);
      });
      saveModal.hide();
    }
  }

  removeModalElement(modalElement: Element) {
    if (modalElement && modalElement.parentElement) {
      modalElement.parentElement.removeChild(modalElement);
    }
  }
  activeTab: string = "";
  playListOpen(route: boolean = true) {
    this.nameDisplay = "";
    this.activeTab = "playlistDiv";
    this.selectedView = 5;
    this.playListview = !this.playListview;
    this.isPrevCardFolders = false;
    this.tabViewHandler("public");
    this.lastViewedCollection = "public";
     this.resetDateFilter();
      this.resetDatePlaceholder();

    if (route) {
      this.router.navigate(["/collection"], {
        queryParams: { type: "public" },
      });
    }
  }

  AllPlayList: any;
  PlayListNames: any = [];
  collectionTags: string = "";
  collectionType: string = "Public";
  playList = [];

  addCollectionType(string: any) {
    this.collectionType = string;
  }

  createPlayLists(body) {
    let name = body.name;
    let type = body.type;

    body = {
      play_list: { name: name, type: type, data: this.OneCardDetails[0] },
    };
    this.mediaService.createPlayList(body).subscribe(
      (res) => {},
      (err) => [console.log(err)]
    );
  }

  createCollection() {
    if (this.collectionTags && this.collectionType) {
      this.playList.push({
        name: this.collectionTags,
        type: this.collectionType,
      });
    }

    this.createPlayLists(this.playList[0]);
  }
  selectPlayList: boolean = false;
  selectPlayListPlay: boolean = false;
  selectPlayListReq: boolean = false;
  showPlayList: any = [];
  isPrevCardFolders: boolean = false;
  showPublicFolder = true;
  lastViewedCollection: string = "public";
displayPlayList(
  id: any,
  index: any,
  type: boolean,
  userId: string,
  route: boolean = true
) {
  // if (route) {
  //   this.hasRouteChanged = false;
  //   this.router.navigate([], {
  //     queryParams: { type: this.lastViewedCollection, id },
  //   });
  // }

  this.backView = this.lastViewedCollection;

  this.cardData.map((cards, idx) => {
    if (cards._id === id) {
      this.mediaService.mediaData = cards.media;
      this.cardData = this.mediaService.mediaData;
      this.allDataForFilter = this.mediaService.mediaData;
      this.cardDataPermanent = this.mediaService.mediaData;
      this.cdRef.detectChanges();


      this.PdfDetails = [];
      this.cardData.forEach((card) => {
        this.totalMedia = this.cardData.length;
        this.uploader_names.push(card);

        if (
          [
            ".pptx",
            ".pdf",
            ".docx",
            ".doc",
            ".xlsx",
            ".xls",
            ".js",
            ".git",
            ".html",
          ].includes(card.extension)
        ) {
          const url = card.ogFileUrl;
          const filename = url.substring(url.lastIndexOf("/") + 1);
          this.orginal = true;
          this.orginalFileName = filename;

          this.PdfDetails.push({
            filename: filename,
            orginal: card.ogFileUrl,
          });

          if (card.extension === ".xlsx" || card.extension === ".xls") {
            this.excelUrl = card.ogFileUrl.replace(/^https?:\/\//, "");
          }
          if (card.extension === ".pptx") {
            this.pptxUrl = card.ogFileUrl;
          }
          if (card.extension === ".pdf") {
            this.pdfUrl = card.ogFileUrl;
          }
          if (card.extension === ".docx" || card.extension === ".doc") {
            this.docsUrl = card.ogFileUrl;
          }
          if (card.extension === ".js") {
            this.jsUrl = card.ogFileUrl.replace(/^https?:\/\//, "");
          }

          this.pdfDisplay = this.pdfDisplay === "none" ? "inline" : "none";
        }
      });

      this.PdfDetails = this.PdfDetails.filter(
        (detail, index, self) =>
          index === self.findIndex((d) => d.filename === detail.filename)
      );
    }
  });

  this.isPrevCardFolders = true;
}

  selectedCollection = "";

  selectedPlayList() {
    let data = this.onlyUserPlaylist.filter(
      (item) => item.name == this.collectionTags
    );
    this.collectionType = data[0].type;
    this.collectionTags = data[0].name;
    this.selectedCollection = this.collectionTags;
    if (this.currentPathPlay.split("/")[1] == "collection") {
      this.selectedView = 6;
    }
  }

  removeOne(id: any, name: string, type: string) {
    let body = { id, name, type };
    this.mediaService.removeFromPlayList(body).subscribe(
      (res) => {},
      (err) => {}
    );
  }

  deletePlayListId(name: string, type: string) {
    let body = { name, type };
    this.mediaService.deletePlayList(body).subscribe(
      (res) => {},
      (err) => {}
    );
  }

  filterPlayList() {
    if (this.selectPlayList) {
    }
  }
  inputValue: string = "";
  play_list_id: "";
  access_password: any;
  createPasword() {
    const chars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let password = "";

    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      password += chars[randomIndex];
    }

    return password;
  }
  selectedSahreFolder: any;
  shareList(id: any) {
    this.selectedSahreFolder = this.cardData.filter((card) => card._id === id);
    this.access_password = this.createPasword();
    this.play_list_id = id;
    this.inputValue = `${window.location.origin}/#/collection/play-list?id=${id}&shareId=${this.access_password}`;
    let saveModalEl = document.querySelector("#shareP");
    let saveModal = new (window as any).bootstrap.Modal(saveModalEl);
    saveModal.show();
    this.getAllUserList();

    var body: any = {
      shareId: this.access_password,
      contentId: id,
      contentType: "COLLECTION",
      sharedUrl: this.inputValue,
      password: this.access_password,
    };
    this.mediaService.sharePlay(body).subscribe(
      (res) => {
        console.log(res);
        // let input = document.getElementById("share-url") as HTMLInputElement;
        // this.inputValue = res["link"];
        // this.access_password = res["password"];
        // input.value = res["link"];
      }
      // (err) => {
      //   // console.log(err);
      // }
    );
  }

  onClickShareCollection() {}

  //Fetching Users on collab dropdown button click
  teams: any;
  teamslength: any;
  canAddMediaId: boolean = true;
  canAddMembersId: boolean = true;
  slelectedCardDAta: any;
  collaborate(cardData: any) {
    this.play_list_id = cardData._id;
    const membersArr = [];
    cardData.members.forEach((crd, idx) => {
      membersArr.push({
        ...crd,
        canAddMedia: this.canAddMediaId,
        canAddMembers: this.canAddMembersId,
      });
    });
    let saveModalEl = document.querySelector("#collaborate");
    let saveModal = new (window as any).bootstrap.Modal(saveModalEl);
    saveModal.show();
    let body = {
      collectionId: cardData._id,
      members: membersArr,
    };
    this.slelectedCardDAta = body;
    this.getAllUserList();
  }

  getSelectedInvite(cardData: any) {
    this.play_list_id = cardData._id;
    const membersArr = [];
    cardData.members.forEach((crd, idx) => {
      membersArr.push({
        memberId: this.memberId,
        memberName: this.membername,
        memberProfileImg: crd.memberProfileImg,
        canAddMedia: this.canAddMediaId,
        canAddMembers: this.canAddMembersId,
      });
    });
    let body = {
      collectionId: cardData.collectionId,
      members: this.member,
    };
    this.mediaService.InvitePlayList(body, cardData).subscribe(
      (res) => {
        this.teams = res["data"].play_list[0].team;
        const uniqueSet = new Set();
        const uniqueArray = this.teams.filter((entry) => {
          const key = `${entry.user}-${entry.id}`;
          if (!uniqueSet.has(key)) {
            uniqueSet.add(key);
            return true;
          }
          return false;
        });

        this.teams = uniqueArray;
        this.teamslength = this.teams.length;
      },
      (err) => {}
    );
  }
  
allUsersOriginal: any[] = [];
resetCollaborateModal() {
  this.searchText = "";
  this.allUsers = JSON.parse(JSON.stringify(this.allUsersOriginal));
  this.filteredUsers = [...this.allUsers]; 
  this.member = []; 
  this.allUsers.forEach(user => (user.invited = false));
}

  //Inviting Users To collab
  member: any[] = [];
toggleInvitation(user: any) {
  if (user.invited) {
    this.member = this.member.filter(m => m.memberId !== user.id);
  } else {
    if (!this.member.some(m => m.memberId === user.id)) {
      this.member.push({
        memberId: user.id,
        memberName: user.username,
        memberProfileImg: user.profile,
        canAddMedia: this.canAddMediaId,
        canAddMembers: this.canAddMembersId,
      });
    }
  }
  user.invited = !user.invited;
}


  //Getting Username List in Collab Modal
  allUsers: any = [];
  getAllUserList() {
    this.UserService.guestList().subscribe(
      (res) => {
        let data = res["data"];
        data.map((user) => {
          this.allUsers.push({
            username: user.userName,
            id: user._id,
            profile: user.profileImg,
          });
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  outFunc() {
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copy to clipboard";
  }

  shareFile(id: any) {
    let body = { user_id: id };
    this.mediaService.sendDetails(this.play_list_id, body).subscribe(
      (res) => {
        alertModalWithoutConfirm("success", "send successfully");
        const modal = document.querySelector("#shareP") as HTMLElement;

        modal.classList.remove("show");

        modal.style.display = "none";
        const backdrop = document.querySelector(
          ".modal-backdrop.show"
        ) as HTMLElement;

        backdrop.style.opacity = "0";
      },
      (err) => {
        alertModal("warning", err.message);
      }
    );
  }

  //Copy the Url on tooltip click in share Modal
  myFunction(id: string) {
    var copyText = document.getElementById(id) as HTMLInputElement;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);

    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copied: ";
  }

  //Filtering Username in collab Modal
  searchText: string = "";
  filteredUsers: any[] = this.allUsers;
  filterUsers() {
    this.filteredUsers = this.allUsers.filter((user) => {
      return user.username
        .toLowerCase()
        .includes(this.searchText.toLowerCase());
    });
  }

  invitationDetails: any[] = [];
  invitationDetailslength: number = 0;
  sendername: any;
  getInvitation() {
    let id = localStorage.getItem("guestID");
    this.activeTab = "playlist";

    this.mediaService.getUserInviteRequest().subscribe(
      (res) => {
        let data = res["data"];
        this.invitationDetails = data;
        this.invitationDetailslength = this.invitationDetails.length;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // acceptInvitation(i) {
  //   let data = this.invitationDetails[i];
  //   data.select = true;
  //   let body = data;
  //   this.mediaService.acceptInvitation(body).subscribe(
  //     (res) => {},
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }

  acceptInvitation(i: number, collaborationId: string, collectionId: string) {
    let data = this.invitationDetails[i];
    data.select = true;
    const body: any = {
      collaborationId: collaborationId,
      collectionId: collectionId,
    };
    body.collaborationId = this.invitationDetails[i]._id;
    this.mediaService.acceptInvitation(body).subscribe(
      (res) => {
        this.invitationDetails.splice(i, 1);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  rejectInvitation(i, collaborationId: string) {
    let data = this.invitationDetails[i];
    const body: any = {
      collaborationId: collaborationId,
    };
    body.collaborationId = this.invitationDetails[i]._id;
    this.mediaService.rejectInvitation(body).subscribe(
      (res) => {
        this.invitationDetails.splice(i, 1);
      },
      (err) => {
        console.log(err);
      }
    );
  }
  playUsers(route: boolean = true) {
    this.selectedView = 6;
    this.selectPlayListPlay = false;
    this.getInvitation();
    this.activeTab = "playlistUser";
    this.isPrevCardFolders = false;
    this.tabViewHandler("private");
    this.lastViewedCollection = "private";
     this.resetDateFilter();
      this.resetDatePlaceholder();

    if (route) {
      this.router.navigate([], {
        queryParams: { type: "private" },
      });
    }
  }

  // goBack() {
  //   window.history.back();
  // }

  goBack() {
    // this.tabViewHandler(this.backView[this.backView.length - 2]);
    if (this.backView === "public") {
      history.back();
    } else if (this.backView === "private") {
      history.back();
    } else {
      this.tabViewHandler(this.backView);
    }
  }

  sendData(data: any[]) {
    this.dataFilterService.updateData(data);
  }

  items: string[] = [];
  isLoading = false;

  toggleLoading = () => (this.isLoading = !this.isLoading);
  // loadData = () => {
  //   this.toggleLoading();
  //   this.paginationService
  //     .getItems(this.selectedLimit, this.selectedLimit)
  //     .subscribe({
  //       next: (response) => (this.items = response),
  //       error: (err) => console.log(err),
  //       complete: () => this.toggleLoading(),
  //     });
  // };

  // this method will be called on scrolling the page
  appendData = () => {
    this.toggleLoading();
    this.mediaService
      .getUserCollection([], this.currentPageNume, this.selectedLimit)
      .subscribe({
        next: (response) => (
          (this.cardData = [...this.cardData, ...response["data"].medias]),
          (this.allDataForFilter = [...this.cardData])
        ),
        error: (err) => console.log(err),
        complete: () => this.toggleLoading(),
      });
  };
  appendPublicCardData = () => {
    this.toggleLoading();
    this.mediaService
      .getPublicCollection([], this.currentPublicPage, this.selectedPublicLimit)
      .subscribe({
        next: (response) =>
          (this.cardData = [...this.cardData, ...response["data"].collections]),
        error: (err) => console.log(err),
        complete: () => this.toggleLoading(),
      });
  };

  onScroll = () => {
    if (this.cardData.length === 100) {
      this.currentPageNume++;
      this.appendData();
    }
  };
  onPublicScroll = () => {
    if (this.cardData.length === 100) {
      this.currentPublicPage++;
      this.appendPublicCardData();
    }
  };

  PublicItems: string[] = [];
  // isPublicLoading = false;

  togglePublicLoading = () => (this.isLoading = !this.isLoading);
  loadPublicData = () => {
    this.toggleLoading();
    this.paginationService
      .getItems(this.selectedLimit, this.selectedLimit)
      .subscribe({
        next: (response) => (this.items = response),
        error: (err) => console.log(err),
        complete: () => this.toggleLoading(),
      });
  };

  // this method will be called on scrolling the page
  appendPublicData = () => {
    this.toggleLoading();
    this.mediaService
      .getPublicCollection([], this.currentPublicPage, this.selectedPublicLimit)
      .subscribe({
        next: (response) =>
          (this.cardData = [...this.cardData, ...response["data"].medias]),
        error: (err) => console.log(err),
        complete: () => this.toggleLoading(),
      });
  };

  currentTabView: string = "normal";
  currentPageNume: number = 1;
  selectedLimit: number = 100;
  totalMedia: number = 0;
  currentPublicPage: number = 1;
  selectedPublicLimit: number = 100;
  backView: string = "normal";
  allPagesData: any[] = [];
  isLoadingMore: boolean = false;
hasMoreData: boolean = true;
currentView: string = '';

tabViewHandler(view: string) {
  console.log("Switching to view:", view);

  this.currentTabView = view;
  this.currentView = view;
  this.cardData = [];
  this.allPagesData = []; 
  this.uploader_names = []; 
  this.isShimmerLoading = true;
  this.hasMoreData = true;

  // Reset pagination variables based on view
  if (view === "grid" || view === "normal") {
    this.currentPageNume = 1;
  } else if (view === "public" || view === "private") {
    this.currentPublicPage = 1;
  }

  this.loadData(view, true);
}


private loadData(view: string, isInitialLoad: boolean = false) {
  let apiCall$;

  if (view === "grid" || view === "normal") {
    apiCall$ = this.mediaService.getUserCollection(
      [],
      isInitialLoad ? 1 : this.currentPageNume,
      this.selectedLimit
    );
  } else if (view === "public") {
    apiCall$ = this.mediaService.getPublicCollection(
      [],
      isInitialLoad ? 1 : this.currentPublicPage,
      this.selectedPublicLimit
    );
  } else if (view === "private") {
    apiCall$ = this.mediaService.getPrivateCollection(
      [],
      isInitialLoad ? 1 : this.currentPublicPage,
      this.selectedPublicLimit
    );
  } else {
    this.isShimmerLoading = false;
    return;
  }

  apiCall$.subscribe(
    (resp: any) => {
      let mediaData: any[] = [];
      let totalItems = 0;

      if (view === "grid" || view === "normal") {
        mediaData = resp.data.medias || [];
        totalItems = resp.data.totalMedias || 0;
        this.totalMedia = totalItems;
      } else {
        mediaData = resp.data.collections || [];
        totalItems = resp.data.totalCollections || 0;
        this.totalMedia = totalItems;
      }

      this.hasMoreData = this.allPagesData.length + mediaData.length < totalItems;

      if (isInitialLoad) {
        this.allPagesData = [...mediaData];
      } else {
        this.allPagesData = [...this.allPagesData, ...mediaData];
      }

      console.log(
        `Loaded ${mediaData.length} items, total accumulated: ${this.allPagesData.length}, has more: ${this.hasMoreData}`
      );

      // ðŸ‘‡ PREPARE PdfDetails here on tab switch
      if (view === "public" || view === "private") {
        this.PdfDetails = [];
        this.allPagesData.forEach((card) => {
          this.handlePuplicFileView(card);
        });
      }

      this.processAndDisplayData(view, mediaData, isInitialLoad);
    },
    (error) => {
      console.error("Error fetching media:", error);
      this.isShimmerLoading = false;
      this.isLoadingMore = false;
      this.hasMoreData = false;
    }
  );
}


private processAndDisplayData(view: string, newData: any[], isInitialLoad: boolean) {
  const tempUploads = this.mediaService.tempUploads
    .filter((card: any) => {
      if (view === "public") return card.isPublic === true;
      if (view === "private") return card.isPublic === false;
      return true; 
    })
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  this.cardData = [...tempUploads, ...this.allPagesData];

  const seenIds = new Set();
  this.cardData = this.cardData.filter((card) => {
    const id = card._id || card.mediaId;
    if (seenIds.has(id)) return false;
    seenIds.add(id);
    return true;
  });

  this.allDataForFilter = [...this.cardData];

  this.uploader_names = [];
  this.cardData.forEach((card) => {
    this.uploader_names.push(card);
  });

  // âœ… Only build PdfDetails for grid/normal here
  if (view !== "public" && view !== "private") {
    this.PdfDetails = [];
    this.cardData.forEach((card) => {
      try {
        if (
          [
            ".pptx",
            ".pdf",
            ".docx",
            ".doc",
            ".xlsx",
            ".xls",
            ".js",
            ".git",
            ".html",
          ].includes(card.extension)
        ) {
          if (card.ogFileUrl) {
            const url = card.ogFileUrl;
            const filename = url.substring(url.lastIndexOf("/") + 1);
            this.PdfDetails.push({ filename, orginal: url });
          } else {
            console.warn("Skipping card with missing ogFileUrl:", card);
          }
        }
      } catch (err) {
        console.error("Error processing card:", card, err);
      }
    });

    this.PdfDetails = this.PdfDetails.filter(
      (detail, index, self) =>
        index === self.findIndex((d) => d.filename === detail.filename)
    );
  }

  this.isShimmerLoading = false;
  this.isLoadingMore = false;

  console.log(
    `Final display: ${this.cardData.length} items, filtered base: ${this.allDataForFilter.length} items`
  );
}



// Add this method for loading more data
loadMoreData() {
  if (this.isLoadingMore || !this.hasMoreData) return;
  
  this.isLoadingMore = true;
  
  if (this.currentView === "grid" || this.currentView === "normal") {
    this.currentPageNume++;
  } else if (this.currentView === "public" || this.currentView === "private") {
    this.currentPublicPage++;
  }
  
  this.loadData(this.currentView, false);
}




handlePuplicFileView(card: any) {
  if (card.media && card.media.length > 0) {
    card.media.forEach((mediaData: any) => {
      if (
        [
          ".pptx",
          ".pdf",
          ".docx",
          ".doc",
          ".xlsx",
          ".xls",
          ".js",
          ".git",
          ".html",
        ].includes(mediaData.extension)
      ) {
        if (!mediaData.ogFileUrl) {
          console.warn("Missing ogFileUrl for media:", mediaData);
          return; // Skip if no file URL yet
        }

        const url = mediaData.ogFileUrl;
        const filename = url.substring(url.lastIndexOf("/") + 1);

        this.orginal = true;
        this.orginalFileName = filename;

        this.PdfDetails.push({
          filename,
          orginal: url,
        });

        if (mediaData.extension === ".xlsx" || mediaData.extension === ".xls") {
          this.excelUrl = url.replace(/^https?:\/\//, "");
        }
        if (mediaData.extension === ".pptx") {
          this.pptxUrl = url;
        }
        if (mediaData.extension === ".pdf") {
          this.pdfUrl = url;
        }
        if (mediaData.extension === ".docx" || mediaData.extension === ".doc") {
          this.docsUrl = url;
        }
        if (mediaData.extension === ".js") {
          this.jsUrl = url.replace(/^https?:\/\//, "");
        }

        this.pdfDisplay = this.pdfDisplay === "none" ? "inline" : "none";
      }
    });
  }
}


  normalView(view: "grid" | "normal") {
    window.location.href = "#/collection";
    let normal = document.querySelector(".onoffswitch-switch") as HTMLElement;
    let removeBox = document.querySelector(".active-tab-underline");
    removeBox?.classList.remove("active-tab-underline");
    this.currentPageNume = 1;
    if (view === "normal") {
      normal.style.left = "0px";
      normal.style.right = "";
      this.tabViewHandler("normal");
       this.resetDatePlaceholder();
        this.resetDateFilter();
    }

    if (view === "grid") {
      normal.style.right = "0px";
      normal.style.left = "";
      this.tabViewHandler("grid");
       this.resetDatePlaceholder();
       this.resetDateFilter();
    }
    
  }

  onlyUserPlaylist: any;
  playUsersList: any;
  getOneUserDetails() {
    let id = localStorage.getItem("guestID");

    this.UserService.getOneUser(id).subscribe(
      (res) => {
        let data = res["data"];
        this.AllPlayList = data.user.play_list;
        this.playUsersList = data.user.play_list;

        const nameAndTypeArray = this.AllPlayList.map((item) => {
          return {
            name: item.play_list[0].name,
            type: item.play_list[0].type,
          };
        });

        this.onlyUserPlaylist = nameAndTypeArray;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  clearSelectedDate() {
    this.resetDatePlaceholder();
    this.resetDateFilter();
    if (this.matSortBy?.nativeElement) {
      this.matSortBy.nativeElement.value = "";
    }
  }

  checkCondition(card, res) {
    return (
      (card.extension == ".pdf" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".pptx" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".xlsx" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".xls" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".docx" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".doc" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".js" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".mp4" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".webm" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".mov" && card.ogFileUrl == res.orginal) ||
      (card.extension == ".mkv" && card.ogFileUrl == res.orginal)
    );
  }
  deleteMedia(id: string) {
    alertModalDelete("You won't be able to revert this!").then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.mediaService.deleteOnyById(id).subscribe(
            (res) => {
              this.router.navigateByUrl("/collection");
              window.location.reload();
            },
            (error) => {
              console.error(error);
              const message = error.error.message || "Something went wrong!";
              alertModalDelete(message);
            }
          );
        } else {
          alertModalDelete("Deletion cancelled");
        }
      }
    );
  }

  deleteCollectionMedia(id: string) {
    alertModalDelete("You won't be able to revert this!").then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.mediaService.deleteCollectionPlaylist(id).subscribe(
            (res) => {
              window.location.reload();
            },
            (error) => {
              console.error(error);
              const message = error.error.message || "Something went wrong!";
              alertModalDelete(message);
            }
          );
        } else {
          alertModalDelete("Deletion cancelled");
        }
      }
    );
  }
  existingCollections: any;
  addToExistingCollection() {
    this.mediaService.getCollectionGroup().subscribe((res) => {
      this.existingCollections = res["data"];
    });
  }

  onAddCollection() {
    var collectionTag = document.querySelector(
      ".collection-input"
    ) as HTMLInputElement;
    this.collectionTags = collectionTag.value;
    var body: any = {
      mediaId: this.mediaId,
    };
    if (this.collectionTags) {
      body.collectionData = {
        title: this.collectionTags,
        isPublic: this.collectionType === "Public" ? true : false,
      };
    } else {
      body.collectionId =
        this.existingCollections[this.selectedCollectionIndex]?._id;
    }
    this.mediaService.addMediaCollection(body).subscribe(
      (res: any) => {
        this.mediaId = res["data"]._id;
      },
      (error: any) => {
        console.error("Error creating collection:", error);
        const message = error.error.message || "Something went wrong!";
        alertModal("error", message);
      }
    );
  }

  selectedPresentations: string[] = [];
  maxSelectionLimit = 10;
  alertShown = false;

  presentationSelection(id: string) {
    const index = this.selectedPresentations.indexOf(id);

    if (index === -1) {
      if (this.selectedPresentations.length < this.maxSelectionLimit) {
        this.selectedPresentations.push(id);

        if (this.selectedPresentations.length === this.maxSelectionLimit) {
          setTimeout(() => {
            alertModalWithoutConfirm(
              "warning",
              `Please Note you can only select ${this.maxSelectionLimit} presentations.`
            );
          }, 4000);
        }
      }
    } else {
      this.selectedPresentations.splice(index, 1);
    }
  }

  getSelectionIndex(pptId: string): number {
    return this.selectedPresentations.indexOf(pptId);
  }

  deckTitle = "";
  isCreating: boolean = false;
  onDeckClick() {
    if (this.selectedPresentations.length === 0) {
      alertModalWithoutConfirm(
        "warning",
        "Please select at least one presentation."
      );
      return;
    }
    ($("#deckTitleModal") as any).modal("show");
  }

  submitDeck() {
    if (!this.deckTitle.trim()) {
      alertModalWithoutConfirm("warning", "Please enter a deck title.");
      return;
    }
    this.isCreating = true;

    const payload = {
      title: this.deckTitle,
      presentationIds: this.selectedPresentations,
    };

    this.UserService.createDeck(payload).subscribe({
      next: (res) => {
        this.isCreating = false;
        console.log("Deck created successfully:", res);
        alertModalWithoutConfirm("success", "Deck created successfully!");
        ($("#deckTitleModal") as any).modal("hide");
        this.deckTitle = "";
        this.selectedPresentations = [];
      },
      error: (err) => {
        console.error("Error creating deck:", err);
      },
    });
  }

  currentLimit = 200;
  allDecks: any[] = [];
  totalDecks: number;
  isLoadingDecks = false;

  getDecks() {
    if (this.isLoadingDecks) return;
    this.isLoadingDecks = true;
    this.currentPageNume = 1;
    this.allDecks = [];

    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.UserService.getAllDecks(field).subscribe({
      next: (res) => {
        console.log("Decks Response:", res);
        const newRecords = res["data"].records || [];
        this.allDecks = [...this.allDecks, ...newRecords];
        this.totalDecks = res["data"].totalCounts;
        ($("#downloadDeckModal") as any).modal("show");
        this.isLoadingDecks = false;
      },
      error: (err) => {
        console.error("Error in decks:", err);
        this.isLoadingDecks = false;
      },
    });
  }

  // Download Decks
  downloadDeck(fileUrl: string) {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "";
    // link.target = '_blank';
    link.click();
  }

  onScrollDeck() {
    console.log("Scrolled! Current Deck Length:", this.allDecks.length);
    const totalLoaded = this.allDecks.length;
    if (totalLoaded >= this.totalDecks) {
      console.log("All decks loaded.");
      return;
    }
    this.currentPageNume++;
    this.getDecks();
  }
}
